// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kgnQy7TLgA8BXVseBV_1{align-items:center;gap:9px;width:100%;margin-top:-3px;display:flex}.YGhWSSxNdIUpxb0S4cRM{flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `kgnQy7TLgA8BXVseBV_1`,
	"registrationRequired": `YGhWSSxNdIUpxb0S4cRM`
};
export default ___CSS_LOADER_EXPORT___;
